import { render, staticRenderFns } from "./ContentItemsView.vue?vue&type=template&id=1b89ba72&"
import script from "./ContentItemsView.vue?vue&type=script&lang=js&"
export * from "./ContentItemsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports